export default class GreetUtil {
  static getGreetingByHours(hours: number): string | undefined {
    if (hours < 12) return "Morning";
    else if (hours >= 12 && hours <= 17) return "Afternoon";
    else if (hours >= 17 && hours <= 24) return "Evening";
  }
}
